import { Column, HeaderFilter, MasterDetail } from "devextreme-react/data-grid";
import { PagedList } from "../../../../core/api/pagedList";
import { t } from "i18next";
import StatisticDetail from "./StatisticDetail";
import { InstructionalVideoWatchStatisticsDto } from "../../model/watchLogDto";
import WatchLogApi from "../../api/watchLogApi";
import { GenericDataGrid } from "../../../../core/components";

interface StatisticsListProps {

}

export default function StatisticsList(props: StatisticsListProps) {
    const fetchData = async (odataQueryParameters?: string): Promise<PagedList<InstructionalVideoWatchStatisticsDto>> => {
        const response = await WatchLogApi.getStatisticsList(odataQueryParameters)
        return response
    }

    return <GenericDataGrid
        id={"WatchLogStatisticsList"}
        className="card m-05"
        rowKey={"video.idInstructionalVideo"}
        fetchData={fetchData}
        columnAutoWidth={true}
        columnHidingEnabled={false}>
        <HeaderFilter visible={false} />
        <Column
            fixed
            fixedPosition="left"
            dataField="video.title" />
        <Column
            dataField="watchedFullyCount"
            caption={t("FullyWatched")}
            width={200}
            cellRender={(cell) => <>{cell.data.watchedFullyCount}/{cell.data.totalUsers}</>} />
        <Column
            dataField="watchedPartiallyCount"
            caption={t("PartiallyWatched")}
            width={200}
            cellRender={(cell) => <>{cell.data.watchedPartiallyCount}/{cell.data.totalUsers}</>} />
        <Column
            dataField="notWatchedCount"
            caption={t("NotWatched")}
            width={200}
            cellRender={(cell) => <>{cell.data.notWatchedCount}/{cell.data.totalUsers}</>} />

        <MasterDetail
            enabled

            component={(cell) => {
                return<StatisticDetail userWatchLogs={cell.data.data.userWatchLogs} />
            }}
        />

    </GenericDataGrid>
}
